import React from 'react'
import DiseñoCard from './DiseñoCard'
import DiseñoButton from './DiseñoButton'
import DiseñoMinimal from './DiseñoMinimal'
import DiseñoCompact from './DiseñoCompact'
import DiseñoClassic from './DiseñoClassic'
import DiseñoGrid from './DiseñoGrid'
import DiseñoLista from './DiseñoLista'
import DiseñoGlass from './DiseñoGlass'
import DiseñoModern from './DiseñoModern'
import DiseñoNeon from './DiseñoNeon'
import { EnlaceUbicacion } from './ComponenteBase'

// Definir los diseños disponibles
export const diseñosDisponibles = [
  // Simples
  {
    id: 'card',
    nombre: 'Card',
    descripcion: 'Diseño de tarjetas clásico',
    icono: '🎴',
    categoria: 'simple'
  },
  {
    id: 'button',
    nombre: 'Button',
    descripcion: 'Botones simples y directos',
    icono: '🔘',
    categoria: 'simple'
  },
  {
    id: 'minimal',
    nombre: 'Minimal',
    descripcion: 'Diseño minimalista',
    icono: '⚪',
    categoria: 'simple'
  },
  {
    id: 'compact',
    nombre: 'Compact',
    descripcion: 'Diseño compacto y eficiente',
    icono: '📦',
    categoria: 'simple'
  },
  {
    id: 'classic',
    nombre: 'Classic',
    descripcion: 'Diseño clásico y elegante',
    icono: '🎩',
    categoria: 'elegante'
  },
  {
    id: 'lista',
    nombre: 'Lista',
    descripcion: 'Formato de lista ordenada',
    icono: '📝',
    categoria: 'simple'
  },
  
  // Elegantes
  {
    id: 'glass',
    nombre: 'Glass',
    descripcion: 'Efecto de cristal moderno',
    icono: '🪟',
    categoria: 'elegante'
  },
  
  // Modernos
  {
    id: 'modern',
    nombre: 'Modern',
    descripcion: 'Diseño moderno y limpio',
    icono: '🔮',
    categoria: 'moderno'
  },
  {
    id: 'grid',
    nombre: 'Grid',
    descripcion: 'Diseño en cuadrícula',
    icono: '⚏',
    categoria: 'moderno'
  },
  
  // Llamativos
  {
    id: 'neon',
    nombre: 'Neon',
    descripcion: 'Efectos de neón brillantes',
    icono: '✨',
    categoria: 'llamativo'
  },
  
  // Profesionales
  {
    id: 'corporate',
    nombre: 'Corporate',
    descripcion: 'Diseño corporativo profesional',
    icono: '💼',
    categoria: 'profesional'
  },
  {
    id: 'business',
    nombre: 'Business',
    descripcion: 'Estilo de negocios elegante',
    icono: '🏢',
    categoria: 'profesional'
  }
]

const RenderizadorDiseño = ({ 
  diseño = 'card', 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracionDiseño = {} 
}) => {
  // Separar enlaces de ubicación de otros enlaces
  const enlacesUbicacion = enlaces.filter(enlace => enlace.tipo === 'ubicacion')
  const otrosEnlaces = enlaces.filter(enlace => enlace.tipo !== 'ubicacion')
  // Función para renderizar el diseño seleccionado con otros enlaces
  const renderizarDiseño = (enlacesParaRenderizar) => {
    if (enlacesParaRenderizar.length === 0) return null

    switch (diseño) {
      case 'card':
        return <DiseñoCard enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'button':
        return <DiseñoButton enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'minimal':
        return <DiseñoMinimal enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'compact':
        return <DiseñoCompact enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'classic':
        return <DiseñoClassic enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'grid':
        return <DiseñoGrid enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'lista':
        return <DiseñoLista enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'glass':
        return <DiseñoGlass enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'modern':
        return <DiseñoModern enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'neon':
        return <DiseñoNeon enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'corporate':
        return <DiseñoClassic enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      case 'business':
        return <DiseñoMinimal enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
      default:
        return <DiseñoCard enlaces={enlacesParaRenderizar} estilosMiniatura={estilosMiniatura} esPreview={esPreview} config={configuracionDiseño} />
    }
  }

  return (
    <div className="space-y-4">
      {/* Renderizar enlaces de ubicación con componente especializado */}
      {enlacesUbicacion.map((enlace, index) => (
        <EnlaceUbicacion 
          key={enlace.id || index} 
          enlace={enlace} 
          estilosMiniatura={estilosMiniatura} 
          esPreview={esPreview} 
        />
      ))}
      
      {/* Renderizar otros enlaces con el diseño seleccionado */}
      {renderizarDiseño(otrosEnlaces)}
    </div>
  )
}

export default RenderizadorDiseño 